<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <template>
      <v-card>
        <v-toolbar dark color="blue">
          Add candidate for position of {{ title }}
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialog">
            <v-icon>mdi-close-circle</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-form
            class="mt-5"
            v-model="addStudentFormValid"
            @submit.prevent="findStudent"
          >
            <v-text-field
              outlined
              label="Select student from accredited voters *"
              prepend-inner-icon="mdi-account-search"
              v-model="registrationNumber"
              hide-details
              clearable
            ></v-text-field>

            <v-btn
              large
              :loading="finding"
              :disabled="finding"
              class="mt-3"
              type="submit"
              color="blue"
              outlined
            >
              Find candidate <v-icon right>mdi-account-search-outline</v-icon>
              <template v-slot:loader>
                <span>Finding...</span>
              </template>
            </v-btn>
          </v-form>

          <section v-if="found">
            <v-divider class="my-5"></v-divider>
            <v-img
              class="shrink mb-2"
              contain
              :src="`${
                student.photo
                  ? `https://uniuyo.edu.ng/eportals/passports/${student.photo}`
                  : '/favicon.png'
              }`"
              transition="scale-transition"
              width="130"
              height="130"
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-3"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
            <table class="table">
              <tbody>
                <tr>
                  <td>Matriculation Number</td>
                  <td>{{ student.reg_number }}</td>
                </tr>
                <tr>
                  <td>Full Name &mdash; (Gender)</td>
                  <td>{{ student.name }} &mdash; ({{ student.gender }})</td>
                </tr>
                <tr>
                  <td>Course of Study</td>
                  <td>{{ student.course_name }}</td>
                </tr>
                <!-- <tr>
                  <td>Department</td>
                  <td>{{ student.department.name }}</td>
                </tr>
                <tr>
                  <td>Faculty</td>
                  <td>{{ student.faculty.name }}</td>
                </tr> -->
              </tbody>
            </table>
          </section>
        </v-card-text>
        <v-card-actions v-if="found" class="pa-6">
          <v-btn
            large
            class="px-5"
            color="secondary"
            @click="addCandidate"
            :loading="adding"
          >
            Add Candidate
            <v-icon right>mdi-archive-plus</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    finding: false,
    adding: false,
    found: false,
    student: {
      department: {name: null},
      faculty: {name: null}
    },
    registrationNumber: null,
    addStudentFormValid: false,
    election: null,
    position: null,
    voter: null,
    title: null,
  }),

  watch: {
    registrationNumber(val) {
      if (val) this.registrationNumber = val.toUpperCase();
    },
  },

  methods: {
    openForm(election, position) {
      this.election = election;
      this.position = position.id;
      this.title = position.description;
      this.dialog = true;
    },
    closeDialog() {
      this.found = false;
      this.dialog = false;
    },
    findStudent() {
      if (!this.registrationNumber) return;

      this.finding = true;
      this.found = false;

      this.$axios
        .get("/election-student", {
          params: {
            registration: this.registrationNumber,
            election: this.election,
          },
        })
        .then(({data: {data: student}}) => {
          this.student = student;

          this.found = true;
        })
        .catch((error) => {
          console.log(error);

          this.found = false;

          this.$bus.$emit("snackbar", {
            type: "error",
            message: "Student not found in accredited voters' list",
          });
        })
        .finally(() => {
          this.finding = false;
        });
    },
    addCandidate() {
      this.adding = true;

      this.$axios({
        url: "/candidates",
        method: "POST",
        data: {
          voter_id: this.student.id,
          election_id: this.election,
          position_id: this.position,
          description: this.description, // Composed of student name and registration number
        },
      })
        .then(() => {
          this.$bus.$emit("election.updated");
          this.closeDialog();
        })
        .catch((error) => {
          if (error.response.status == 409) {
            this.$bus.$emit("snackbar", {
              type: "warning",
              message: "Candidate is already a contestant in this election",
            });
          } else {
            this.$bus.$emit("snackbar", {
              type: "error",
              message: "Could not add candidate",
            });
          }
        })
        .finally(() => {
          this.adding = false;
        });
    },
  },

  mounted() {
    this.$bus.$on("candidate.add", this.openForm);
  },
};
</script>

<style lang="scss" scoped>
.table {
  width: 100%;
  border-collapse: collapse;

  thead {
    tr {
      th {
        text-transform: uppercase;
      }
    }
  }

  tr {
    border-left: 5px solid #c3e7cd;
    border-left: 5px solid #eee1ad;
    border-bottom: thin solid #dddddd;
  }

  tr:nth-of-type(even) {
    background-color: #f3f3f3;
  }

  tr {
    th,
    td {
      padding: 0.75em 1em;
      margin: 0;
    }

    th {
      text-align: left;
    }

    td:nth-child(2) {
      font-weight: 500;
      text-align: right;
    }
  }
}
</style>